document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.images-slider');

	if (!sections.length) {
		return;
	}

	if (typeof Swiper === 'undefined') {
		console.warn('Swiper is not loaded for images-slider block.');
		return;
	}

	sections.forEach((section) => {
		const slider = section.querySelector('.images-slider__swiper');
		const prevButton = section.querySelector('.images-slider__prev');
		const nextButton = section.querySelector('.images-slider__next');

		if (!slider) {
			return;
		}

		if (slider.swiper) {
			return;
		}

		new Swiper(slider, {
			slidesPerView: 1.3,
			spaceBetween: 20,
			speed: 600,
			loop: true,
			watchOverflow: true,

			navigation: {
				prevEl: prevButton,
				nextEl: nextButton,
			},

			breakpoints: {
				768: {
					slidesPerView: 1.6,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1.8,
					spaceBetween: 40,
				},
				1550: {
					slidesPerView: 2,
					spaceBetween: 40,
				}
			},
		});
	});
});